import React from 'react';
import styles from './GearComparePageSkeleton.module.css';

const GearComparePageSkeleton = () => {
  const dummyItems = [1, 2, 3];
  const dummyRows = [1, 2, 3, 4];

  return (
    <div className={styles.skeletonPage}>
      <div className={styles.comparisonWrapper}>
        <div className={styles.comparisonTable}>
          <div className={`${styles.comparisonRow} ${styles.headerRow}`}>
            <div className={styles.rowLabel}></div>
            {dummyItems.map((item) => (
              <div key={`header-${item}`} className={styles.comparisonCell}>
                <div className={styles.cardTop}>
                  <div className={styles.nameSkeleton}></div>
                  <div className={styles.brandSkeleton}></div>
                </div>
                <div className={styles.imageSkeleton}>
                  <div className={styles.shimmer}></div>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.comparisonRow}>
            <div className={styles.rowLabel}>
              <div className={styles.labelSkeleton}></div>
            </div>
            {dummyItems.map((item) => (
              <div key={`price-${item}`} className={styles.comparisonCell}>
                <div className={styles.priceSkeleton}></div>
              </div>
            ))}
          </div>

          {dummyRows.map((row) => (
            <div key={`row-${row}`} className={styles.comparisonRow}>
              <div className={styles.rowLabel}>
                <div className={styles.labelSkeleton}></div>
              </div>
              {dummyItems.map((item) => (
                <div key={`cell-${row}-${item}`} className={styles.comparisonCell}>
                  <div className={styles.textSkeleton}></div>
                  <div className={styles.textSkeletonShort}></div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GearComparePageSkeleton;